import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import OrderInformationSectionEmpty from 'components/workflow/OrderInformation/OrderInformationSectionEmpty';

const OrderInformationReferralSourceEmpty = ({ onAddButtonClick }) => (
  <Field
    id="Referral Source ID"
    name="Referral Source ID"
    component={OrderInformationSectionEmpty}
    title="Referral Source"
    text="There are no referrals"
    type="referralSource"
    onAddButtonClick={onAddButtonClick}
  />
);

OrderInformationReferralSourceEmpty.propTypes = {
  onAddButtonClick: PropTypes.func,
};

OrderInformationReferralSourceEmpty.defaultProps = {
  onAddButtonClick: () => {},
};

export default OrderInformationReferralSourceEmpty;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationReferralSource/OrderInformationReferralSourceEmpty.js